<nav class="navbar navbar-expand-lg navbar-light bg-light ml-auto sticky-top">
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarSupportedContent">

    <a class="navbar-brand" routerLink="/" title="Dauernd gut versorgt GmbH">
      <img src="/assets/img/daguve-logo-text.png" height="30" alt="Dauernd gut versorgt GmbH">
    </a>

    <span *ngIf="showTestLabel">
      <strong class="test-label">Testsystem</strong>
    </span>

    <ul class="navbar-nav" *ngFor="let role of userRoles">

      <li class="nav-item" *ngFor="let link of getNavigation(role, 'link')">
        <a class="nav-link clickable" routerLink="{{link.url}}" title="{{link.label}}">
          <i class="{{link.icon}}"></i>
        </a>
      </li>
    </ul>

    <ul class="navbar-nav" *ngFor="let role of userRoles">

      <div class="dropdown" aria-labelledby="navDropdown" *ngFor="let dropdown of getNavigation(role, 'dropdown')">
        <a class="nav-link clickable dropdown-toggle" role="button" title="{{dropdown.title}}" data-toggle="dropdown"
          aria-haspopup="true" aria-expanded="false">
          <i class="{{dropdown.icon}}"></i>
        </a>

        <div class="dropdown-menu" aria-labelledby="navDropdown">
          <a class="dropdown-item" routerLink="{{page.url}}" title="{{page.label}}"
            *ngFor="let page of getPages(dropdown)">
            <i class="{{page.icon}}"></i> {{page.label}}
          </a>
        </div>

      </div>

    </ul>

    <!-- Login und Logout, je nachdem ob der Benutzer ein oder ausgeloggt ist-->
    <ul class="navbar-nav ml-auto">
      <li class="nav-item">
        <a class="nav-link clickable" routerLink="logout" title="Abmelden" *ngIf="userIsLoggedIn">
            <i class="fas fa-sign-out-alt"></i>
        </a>
      </li>
    </ul>
  </div>
</nav>
